import { useAtom } from "jotai";
import { workScheduleShiftListJsonAtom } from "../store/store";
import { WorkScheduleShift, ReportParams } from "../types";
import { useQuery } from "@apollo/client";
import {
  midgardClients,
  WORK_SCHEDULE_SHIFT_LIST_FULL_QUERY,
} from "providers/MidgardProvider";
import { ONE_SECOND_OF_MS } from "./timeUtils";
import { useParams } from "react-router";

export const useGetWorkScheduleShiftList = ({
  tenant,
  work_schedule_id,
  ordinal,
}: {
  tenant?: string;
  work_schedule_id?: string;
  ordinal?: number;
}): void => {
  const [, setWorkScheduleShiftListJson] = useAtom(
    workScheduleShiftListJsonAtom
  );
  const { ckey } = useParams() as ReportParams;
  const query_variables = {};
  if (work_schedule_id) {
    query_variables["id"] = work_schedule_id;
  }
  if (ordinal) {
    query_variables["ordinal"] = ordinal;
  }

  const tenantOrCKey = tenant || ckey;
  const { loading, refetch, error } = useQuery(
    WORK_SCHEDULE_SHIFT_LIST_FULL_QUERY,
    {
      client: midgardClients.get(tenantOrCKey),
      skip: !tenantOrCKey || tenantOrCKey === "admin",
      variables: query_variables,
      onError: err => {
        // refetch after a 10 second delay
        setTimeout(refetch, 10 * ONE_SECOND_OF_MS);
        console.log(`Work schedule shift list query gone wrong. cKey: ${ckey}`);
        console.log(`${err}: retrying in 10 seconds`);
      },
      onCompleted: data => {
        if (data?.workScheduleShiftList && !loading && !error) {
          setWorkScheduleShiftListJson(
            data.workScheduleShiftList as WorkScheduleShift[]
          );
        }
      },
    }
  );
};

export const useGetWorkScheduleShiftListJson = () => {
  const [workScheduleShiftListJson] = useAtom(workScheduleShiftListJsonAtom);

  const shiftsAsArray = workScheduleShiftListJson
    ? workScheduleShiftListJson
    : [];

  const sortedShifts = shiftsAsArray
    .slice()
    .sort((a, b) => a.startTime.localeCompare(b.startTime));

  return sortedShifts;
};
